import React from 'react';
// @ts-ignore
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalDialog,
    ModalHeader,
    ModalFooter,
    Link,
    Loader,
    Button,
} from 'arag-ui-lib';
import PolicyHolderClaimRejectedForm from '../policyHolderClaimRejectedForm/policyHolderClaimRejectedForm';
import { Form, Formik, FormikValues } from 'formik';
import {
    PrimaryButton,
    SecondaryButton,
    SmallModal,
} from '../../hosc/modals/modals';
import { useTranslation } from 'react-i18next';

type Props = {
    rejectClaimReviewWithReason: (values: {
        acceptanceStatusReason: any;
    }) => void;
    rejectedReasonClaimReviewWordings: any;
    submitting: boolean;
    changeClaimReviewStateAction: any;
};
const PolicyHolderClaimRejectedModal = (props: Props): JSX.Element => {
    const {
        rejectClaimReviewWithReason,
        rejectedReasonClaimReviewWordings,
        submitting,
        changeClaimReviewStateAction,
    } = props;
    const { t } = useTranslation();
    return (
        <Modal
            id={'review_claim_modal_rejection'}
            fadeIn={Boolean(rejectedReasonClaimReviewWordings)}
            darkenedBackground
            noScroll={true}
        >
            <ModalDialog id={'review_claim_modal_rejection_dialog'}>
                <ModalContent id={'review_claim_modal_rejection_content'}>
                    <ModalHeader
                        id={'review_claim_modal_rejection_header'}
                        title={rejectedReasonClaimReviewWordings.pageTitle}
                        onClose={() =>
                            changeClaimReviewStateAction({
                                rejectedReasonClaimReview: null,
                            })
                        }
                    />
                    <Formik
                        initialValues={{} as any}
                        onSubmit={rejectClaimReviewWithReason}
                    >
                        {({ formikProps }: FormikValues) => {
                            return (
                                <Form
                                    className="form-horizontal"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    spellCheck="false"
                                    id="rejected_claim_form"
                                >
                                    <ModalBody
                                        id={
                                            'review_claim_modal_rejection_body_wrapper'
                                        }
                                    >
                                        <PolicyHolderClaimRejectedForm
                                            rejectedReasonClaimReviewWordings={
                                                rejectedReasonClaimReviewWordings
                                            }
                                            changeClaimReviewStateAction={
                                                changeClaimReviewStateAction
                                            }
                                            formikProps={formikProps}
                                        />
                                    </ModalBody>
                                    <ModalFooter>
                                        <SmallModal>
                                            <SecondaryButton>
                                                <div>
                                                    <Link
                                                        id={'go_back'}
                                                        onClick={() =>
                                                            changeClaimReviewStateAction(
                                                                {
                                                                    rejectedReasonClaimReview:
                                                                        null,
                                                                },
                                                            )
                                                        }
                                                        label={t('goBack')}
                                                        variant="tertiary"
                                                        arrowDirection="left"
                                                    />
                                                </div>
                                                {submitting && (
                                                    <Loader
                                                        id={
                                                            'rejected_claim_review_loader'
                                                        }
                                                        variant="inline"
                                                        label={t('submitting')}
                                                    />
                                                )}
                                            </SecondaryButton>
                                            <PrimaryButton>
                                                <Button
                                                    id={'rejected_claim_review'}
                                                    type="submit"
                                                    variant="primary"
                                                    label={t('submit')}
                                                    arrowDirection="left"
                                                />
                                            </PrimaryButton>
                                        </SmallModal>
                                    </ModalFooter>
                                </Form>
                            );
                        }}
                    </Formik>
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

export default PolicyHolderClaimRejectedModal;
